import router from "./router";
import store from "./store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import getPageTitle from "./api/get-page-title";

NProgress.configure({
    showSpinner: false,
});

router.beforeEach((to, from, next) => {
        // hasToken 要每次進來都抓不然不會改變
        let hasToken = store.state.token;

        // 優先讀 state.token，若無則從 localStorage 的 userInfo.refresh_token 判斷是否登入
        if (!hasToken) {
            try {
                const stored = window.localStorage.getItem("userInfo");
                const userInfo = stored ? JSON.parse(stored) : null;
                hasToken = userInfo && userInfo.refresh_token ? userInfo.refresh_token : '';
            } catch (e) {
                hasToken = '';
            }
        }

        NProgress.start();
        document.title = getPageTitle(to.meta.title);
        store.dispatch("SaveHistory", from);

        if (!to.name) {
            return next();
        }

        // 排除桌面登入('login')、登出頁，避免無限重定向
        const isLoginOrLogout = ['login', 'm-logout', 'm-logoutauto'].includes(to.name);
        if (isLoginOrLogout) {
            return next();
        }

        if (!hasToken) {
            console.log("尚未登入!, 跳轉到登入頁面");
            // 行動版路由（/m/...）一律導向桌面登入頁，並帶 redirect 參數
            if (to.path && to.path.startsWith('/m/')) {
                return next(`/BIDSHome?redirect=${encodeURIComponent(to.fullPath)}`);
            }
            return next('/BIDSHome');
        }

        if (!store.state.menuList) {
            // console.log("發現menuList不見了.. 重新load menu");
            store.dispatch("ReloadMenu");
            // console.log("重新load menu完成");
        }

        return next();
});
router.afterEach(() => {
    NProgress.done();
})